import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  IconButton,
} from "@mui/material";
import imgBackgroundDialogTitle from "assets/images/bg-dialog-title.png";
import { Button, PlusSquareIcon, XCloseIcon } from "components";
import { gray } from "configs/colors";

interface Props extends DialogProps {
  header?: React.ReactNode;
  body: React.ReactNode;
  footer?: React.ReactNode;
  isDefault?: boolean;
}

const IndexPage: React.FC<Props> = ({
  header,
  body,
  footer,
  isDefault,
  ...innerProps
}) => {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Dialog {...innerProps}>
      <DialogTitle
        sx={{
          padding: "0px",
          backgroundImage: isDefault
            ? null
            : `url(${imgBackgroundDialogTitle})`,
          backgroundRepeat: "no-repeat",
        }}
      >
        <Box
          sx={{ padding: "28px 28px 14px 28px" }}
          display="flex"
          gap="14px"
          position="relative"
          paddingRight={10}
        >
          {isDefault ? null : (
            <Box flex="0 0 auto">
              <Button variant="outlined" color="inherit" size="icon-lg">
                <PlusSquareIcon fontSize="small" />
              </Button>
            </Box>
          )}
          <Box>{header}</Box>
          {isDefault ? null : (
            <IconButton
              onClick={innerProps.onClose as unknown as () => void}
              sx={{
                position: "absolute",
                right: 12,
                top: 12,
                color: gray[500],
              }}
            >
              <XCloseIcon />
            </IconButton>
          )}
        </Box>
      </DialogTitle>
      <DialogContent sx={{ padding: "42px" }}>{body}</DialogContent>
      {footer ? (
        <DialogActions sx={{ padding: "24px 44px" }}>{footer}</DialogActions>
      ) : null}
    </Dialog>
  );
};

export default IndexPage;
